import { ILiveMessageDTO } from '@elyx-code/definitions';

export function parseRTCMessage(data: string): ILiveMessageDTO | string {
	try {
		const jsonObject = JSON.parse(data);
		return jsonObject;
	} catch (e) {
		return data;
	}
}
